export class User {
  _id?: any;
  username?: string;
  firstName?: string;
  lastName?: string;
  image?: string;
  email?: string;
  emailConfirmed?: boolean;
  password?: string;
  resetPasswordToken?: string;
  department?: string;
  job?: string;
  office?: string;
  role?: string;
  site?: string;
  created_at?: Date;
  lastLogin?: Date;
  lastActivityCount?: number;
  _clients?: any[];
  driveurl?: string;
  utopiaurl?: string;
  permissions?: string[];
  emailNotifications?: string[];
  disabled?: boolean;
}
